import _ from 'lodash'
import moment from 'moment'

export default (user, cart) => {
  const active_subscriptions = {}
  _.forEach(
    _.pick(user, 'pats_exp_date', 'reprog_exp_date', 'sub_exp_date', 'ids_exp_date', 'mdars_exp_date', 'training_exp_date'),
      (value, key) => {
      let newKey = ''
      switch(key) {
        case 'pats_exp_date':
          newKey = 'PATS'; break
        case 'reprog_exp_date':
          newKey = 'PCM'; break
        case 'mdars_exp_date':
          newKey = 'MDARS'; break
        case 'training_exp_date':
          newKey = 'TRAINING'; break
        case 'ids_exp_date':
          newKey = 'IDS'; break
        case 'sub_exp_date':
          newKey = 'ESI'; break
      }
      active_subscriptions[newKey] = moment(value).isAfter(moment())
    }
  )

  const hasPatsProductInCart = cart.some(item => item.product_type.key === 'PATS')

  if (hasPatsProductInCart) {
    const allowedToAddPats = active_subscriptions['IDS'] || active_subscriptions['PCM'] || active_subscriptions['MDARS']
    if (!allowedToAddPats) {
      cart = cart.filter(item => item.product_type.key !== 'PATS')
    }
  }
  return cart.filter(item => !active_subscriptions[item.product_type.key])
}



// WEBPACK FOOTER //
// ./lib/filterCartItems.js